import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import logo from '../../images/logo-h.svg'
const LogoWraper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 0 10px; */
  height: 100px;
  @media (max-width: 768px) {
    height: 60px;
    padding-left: 20px;
  }
  a{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 235px;
    @media (max-width: 768px) {
      width: 150px;
    }
  }
`

const Logo = () => {
  return (
    <LogoWraper>
      <Link to="/">
        <img src={logo} alt='锦江城市服务' />
      </Link>
    </LogoWraper>
  )
}

export default Logo
